var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_2443)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45,
    r: 45,
    fill: "url(#paint0_linear_636_2443)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45,
    r: 44,
    stroke: "url(#paint1_linear_636_2443)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4998 31.6667C47.2679 31.6667 48.9636 32.3691 50.2139 33.6193C51.4641 34.8695 52.1665 36.5652 52.1665 38.3333C52.1665 40.1014 51.4641 41.7971 50.2139 43.0474C48.9636 44.2976 47.2679 45 45.4998 45C43.7317 45 42.036 44.2976 40.7858 43.0474C39.5355 41.7971 38.8332 40.1014 38.8332 38.3333C38.8332 36.5652 39.5355 34.8695 40.7858 33.6193C42.036 32.3691 43.7317 31.6667 45.4998 31.6667ZM45.4998 58.3333C45.4998 58.3333 58.8332 58.3333 58.8332 55C58.8332 51 52.3332 46.6667 45.4998 46.6667C38.6665 46.6667 32.1665 51 32.1665 55C32.1665 58.3333 45.4998 58.3333 45.4998 58.3333Z",
    fill: "url(#paint2_linear_636_2443)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_636_2443",
    x1: 0.5,
    y1: 0,
    x2: 95.9768,
    y2: 75.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737429,
    stopColor: "#01CFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D3CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_636_2443",
    x1: 0.5,
    y1: 0,
    x2: 95.9768,
    y2: 75.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737429,
    stopColor: "#01CFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D3CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_636_2443",
    x1: 32.1665,
    y1: 31.6667,
    x2: 57.6211,
    y2: 57.5253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630311,
    stopColor: "#01CFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D3CD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_2443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.9c8a44e56c10d20f7485e1a39ef79ad8.svg";
export { ForwardRef as ReactComponent };